/**
 * Internal dependencies
 */
import { makeLayout, render } from "lib/controller";
import { login, eurekaCallback } from "./controller";

export default (router) => {
  router(`/login/callback/eureka`, eurekaCallback, makeLayout, render);
  router(`/login`, login, makeLayout, render);
};
